import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { SelectEvent } from '@models/forms.interface';

@Component({
  selector: 'app-radio-button-field',
  standalone: true,
  imports: [
    MatRadioModule,
    MatFormFieldModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.component.scss',
})
export class RadioButtonFieldComponent implements OnInit {
  @Input() name = '';
  @Input() label = '';
  @Input() value = '';
  @Input() defaultOption;
  @Input() selectOptions = '';
  @Input() customErrorMessage = '';
  @Input() isRequired = false;
  @Output() selectedOption = new EventEmitter<SelectEvent>();

  public form!: FormGroup;
  public textInputField = new FormControl(this.value);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(private formGroupDirective: FormGroupDirective) {}

  public selectedValue(change: MatRadioChange) {
    this.selectedOption.emit({
      name: this.name,
      value: change.value,
      selectionChangeEvent: null,
    });
  }

  ngOnInit(): void {
    this.form = this.formGroupDirective.control;

    const validators: ValidatorFn[] = [];

    if (this.isRequired) {
      validators.push(Validators.required);
    }
  }
}
